import {useNavigation} from '@react-navigation/native';
import {openExternalLink} from '../../pipes';
import {Props} from './model';
import View from './view';

export const ExternalLink = (props: Props) => {
  const isDownloadable = false;
  const onPress = async () => {
    openExternalLink(props.link);
  };
  const nav = useNavigation();

  return View({
    ...props,
    navigate: nav.navigate,
    onPress,
    isDownloadable,
  });
};
